import React from 'react'
import { useAuthState} from "../Context/auth-context";
import Home from "./Home";
import Hdash from "./dashboard/Hdash";
export default function ManageHome() {

    const {isAuth} = useAuthState()
    const {loading} =  useAuthState()






    return (
        <>

           {!loading ?
                <>

                    {isAuth ? <Hdash/> : <Home/>}
                </>
                :
                <>
                    <div className={'text-center mt-5 pt-5'}>
                    <div className={'text-center full-body5656'}>


                    <img src={'../img-camp/loading.svg'}/>

                    </div>   
                                     </div>
                </>
            }


        </>

    )

}



